import { ScreenSources } from '@walter/shared/constants/posthog'
import { VerificationLevel } from '@web/walter-lib/api'
import { useCallback, useMemo } from 'react'
import { useAccountUserInfo } from '~api'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { SettingsTabs } from '~modals/SettingsModal/Menu/const'
import { useSettingsModal } from '~modals/SettingsModal/useSettingsModal'

export type ReceiveVerificationReason = 'verify' | 'unavailable'

export const useReceiveVerificationLogic = () => {
    const { data, error, isLoading } = useAccountUserInfo()
    const { setTab: setSettingsTab } = useSettingsModal()

    const value = useMemo(() => {
        let reason: ReceiveVerificationReason | undefined

        if (data?.verification_level) {
            if (data?.verification_level === VerificationLevel.STARTER_NONE) {
                reason = 'verify'
            } else if (data?.verification_level === VerificationLevel.NOT_YET) {
                reason = 'unavailable'
            }
        }

        return {
            disabled: data ? !!reason : true,
            disabledReason: reason,
        }
    }, [data])

    const { show: showAssetLimitsModal } = useModal(ModalTypes.assetLimits)

    const goToVerify = (state?: { from: ScreenSources }) => setSettingsTab(SettingsTabs.identity, state)

    const showModal = useCallback(
        (screenSource?: ScreenSources) => {
            showAssetLimitsModal({ disabledReason: value.disabledReason, screenSource })
        },
        [showAssetLimitsModal, value.disabledReason]
    )

    return { ...value, showModal, goToVerify, data, error, isLoading }
}
